import Login from './Authentication/login';

import Signup from './Authentication/signup';
import ForgotPassword from './Authentication/forgotpassword';
import NotFound from './Authentication/404';
import Maintenance from './Authentication/maintenance';
import Summary from './Dashboard/Summary';
import ASMDashboard from './Dashboard/ASMDashboard';
import DataDashboard from './Dashboard/DataDashboard';
import BrandDashboard from './Dashboard/BrandDashboard';
import VendorSummary from './Dashboard/VendorSummary';
import BreachSummary from './Dashboard/BreachSummary';
import NewSummary from './Dashboard/newsummary';
import Dashboard2 from './Dashboard/dashboard2';
import Dashboard3 from './Dashboard/dashboard3';
import Dashboard4 from './Dashboard/dashboard4';
import Dashboard5 from './Dashboard/dashboard5';
import Dashboard6 from './Dashboard/dashboard6';
import Dashboard7 from './Dashboard/dashboard7';
import Dashboard8 from './Dashboard/dashboard8';
import Dashboard9 from './Dashboard/dashboard9';
import Dashboard10 from './Dashboard/dashboard10';
import Dashboard11 from './Dashboard/dashboard11';
import Dashboard12 from './Dashboard/dashboard12';
import AssetsDiscovery from './SecurityRisk/assetsdiscovery';
import KnownVulnerabilities from './SecurityRisk/KnownVulnerabilities';
import InfrastructureVA from './VulnerabilityAssessment/InfrastructureVA';
import InfrastructureVAIP from './VulnerabilityAssessment/InfrastructureVAIP';
import ApplicationVA from './VulnerabilityAssessment/ApplicationVA';
import ScanPage from './VulnerabilityAssessment/ScanPage';
import ExpiredSSLCertificates from './SecurityRisk/ExpiredSSLCertificates';
import WebTechnology from './SecurityRisk/WebTechnology';

import SecurityHeader from './SecurityRisk/securityHeader';
import Domains from './SecurityRisk/SubDomain';
import SPFDMARC from './SecurityRisk/SPFDmarc';
import BrandMention from './SecurityRisk/BrandMention';
import SeoPoisoning from './SecurityRisk/SeoPoisoning';
import SubDomainDiscovery from './SecurityRisk/SubDomainDiscovery';
import DanglingSubDomains from './SecurityRisk/DanglingSubDomains';

import LookAlikeDomains from './SecurityRisk/LookAlikeDomain';
import SocialMediaProfile from './SecurityRisk/SocialMediaProfile';
import SocialMediaData from './SecurityRisk/SocialMediaData';
import WebDefacement from './SecurityRisk/WebDefacement';

import MobileApp from './SecurityRisk/MobileApp';
import RedTeaming from './SecurityRisk/RedTeaming';
import RedTeamingDashboard from './SecurityRisk/RedTeamingDashboard';
import RedTeamingAssets from './SecurityRisk/RedTeamingAssets';
import RedTeamingAttackTypes from './SecurityRisk/RedTeamingAttackTypes';
import RedTeamingResults from './SecurityRisk/RedTeamingResults';
import SimulationDetails from './SecurityRisk/SimulationDetails';
import RedTeamingSettings from './SecurityRisk/RedTeamingSettings';
import StolenCredentials from './BreachRisk/StolenCredentials';
import PII from './BreachRisk/pii';
import PhishingPage from './SecurityRisk/phishingPage';
import PasteBin from './BreachRisk/PasteBin';
import MalwareCredentials from './BreachRisk/MalwareCredentials';
import LeakedSessions from './BreachRisk/LeakedSessions';
import Telegrammonitoring from './BreachRisk/Telegrammonitoring';
import PostmanMonitoring from './BreachRisk/PostmanMonitoring'


import SourceCodeLeakage from './BreachRisk/SourceCodeLeakage';
import IPBlacklist from './BreachRisk/IPBlacklist';
import FeedInformation from './information/FeedInformation';
import ShowInformation from './information/ShowInformation';
import CloudBuckets from './BreachRisk/CloudBuckets';
import CloudAccounts from './cspm/CloudAccounts';
import CloudAccountDetails from './cspm/CloudAccountDetails';
import ScanResults from './cspm/ScanResults';
import Integrations from './integrations/Integrations';

import FormAdvanced from './Form/formAdvanced';
import FormBasic from './Form/formsBasic';
import FormCropping from './Form/formsCropping';
import FormDragdropupload from './Form/formDragdropupload';
import FormsEditors from './Form/formsEditors';
import FormSummernote from './Form/formSummernote';
import FormValidation from './Form/formValidation';
import FormWizard from './Form/formWizard';
import ListView from './Contacts/ListView';
import GridView from './Contacts/GridView';
import Inbox from './Email/Inbox';
import Compose from './Email/Compose';
import Details from './Email/Details';
import Chat from './Messenger/chat';
import ProjectList from './Projects/ProjectList';
import InviteUser from './Projects/InviteUser';
import TicketList from './Projects/TicketList';
import TicketDetails from './Projects/TicketDetails';
import Taskboard from './Projects/Taskboard';
import TodoList from './Projects/TodoList';
import Clients from './Projects/Clients';
import TrialRequest from './Projects/trialRequest';
import TakeDownRequest from './Projects/takeDownRequest';
import Vendors from './Projects/Vendors';
import ForestView from './Projects/ForestView';
import Icons from './UI/Icons';
import SimpleLine from './UI/SimpleLine';
import Themify from './UI/Themify';
import Bootstrap from './Components/Bootstrap';
import Typography from './Components/Typography';
import RangeSliders from './Components/RangeSliders';
import Tabs from './Components/Tabs';
import ProgressBars from './Components/ProgressBars';
import Notifications from './Components/Notifications';
import Modals from './Components/Modals';
import Calendar from './Calendar/Calendar';
import ApexChart from './Chart/apexChart';
import jVector from './Map/jVector';
import PageSocial from './Pages/pageSocial';
import PageNews from './Pages/pageNews';
import PageBlogPost from './Pages/pageBlogPost';
import PageBlog from './Pages/pageBlog';
import pageBlank from './Pages/pageBlank';
import pageProfile from './Pages/pageProfile';
import CompanyProfile from './Pages/CompanyProfile';
import Settings from './Pages/Settings';
import Subscription from './Pages/Subscription';
import Configuration from './Pages/Configuration';
import pageUserList from './Pages/pageUserList';
import PageTestimonials from './Pages/pageTestimonials';
import PageInvoiceDetails from './Pages/pageInvoiceDetails';
import PageInvoice from './Pages/pageInvoice';
import PageTimeline from './Pages/pageTimeline';
import PageSearchResult from './Pages/pageSearchResult';
import PageGallery from './Pages/pageGallery';
import PagePricing from './Pages/pagePricing';
import PageComingSoon from './Pages/pageComingSoon';
import Widgets from './Widgets/Widgets';
import TableColor from './Table/tableColor';
import TableDragger from './Table/tableDragger';
import TableEditable from './Table/tableEditable';
import TableFilter from './Table/tableFilter';
import TableJqueryDatatable from './Table/tableJqueryDatatable';
import TableNormal from './Table/tableNormal';
import Colors from './Components/Colors';
import Buttons from './Components/Buttons';
import Dialogs from './Components/Dialogs';
import ListGroup from './Components/ListGroup';
import MediaObject from './Components/MediaObject';
import Nestable from './Components/Nestable';
import CVEinformation from './Projects/CVEInformation';
import CVEinformationEdit from './Projects/CVEInformationEdit';
import vendorProduct from './Projects/vendorandProduct';
import PostManMonitoringDetail from './BreachRisk/PostMonitoringDetail';
import DarkWeb from './BreachRisk/DarkWeb';
import cveMonitoring from './Projects/CveMonitoring';
import Technology from './Projects/Technology';
import ForestRatingPage from './Projects/forestRatingList';
import HighRisk from './Projects/highRisk';
import PendingRemdiation from './Dashboard/PendingRemdiation';
import VipEntities from './Dashboard/VipEntities';
import RiskManagement from './RiskManagement/riskmanagementdashboard';
import Questionnaires from './RiskManagement/questionnaires';
import RiskRegister from './RiskManagement/risk-register';
import VendorRisk from './RiskManagement/vendorrisk';
import SendQuestionnaires from './RiskManagement/sendquestionnaires';
import CreateTemplate from './RiskManagement/createtemplate';
import VendorQuestionnaireDashboard from './RiskManagement/vendorquestionnairesdashboard ';
import ShowDetailsVendorQuestionnaires from './RiskManagement/showdetailsquestionnaires';
import ReviewResponse from './RiskManagement/reviewResponse';
import RiskRegisterChat from './RiskManagement/risk-rigister-details';
import VendorRiskRegister from './RiskManagement/vendorRiskRegistor';
import RiskRegisterVendorChat from './RiskManagement/vendorRiskRegisterDetails';
import ActiveVaDetails from './VulnerabilityAssessment/activeVaDetails';
import AlertIntegration from './integrations/AlertsIntegrations';
import ThreatIntelSearch from './ThreatIntel/Search';
import HostDetails from './SecurityRisk/ipDetails';
import CustomReport from './Reports/CustomReport';
import RansomwareTracker from './ThreatIntel/RansomwareTracker';
import HacktivismTracker from './ThreatIntel/HacktivismTracker';
import ThreatIntelFeeds from './ThreatIntel/Feeds';
import ThreatIntelFeed from './ThreatIntel/ThreatIntelFeed';
import TrustPanel from './RiskManagement/trustPanel';
import ApplicationSecurity from './SecurityRisk/ApplicationSecurity';
import ConsolidatedAssets from './SecurityRisk/ConsolidatedAssets';
import ConsolidatedRisks from './SecurityRisk/ConsolidatedRisks';
import ThreatActorList from './ThreatIntel/ThreatActorList';
import ThreatActorDetails from './ThreatIntel/ThreatActorDetails';
import ThreatIntelDashboard from './ThreatIntel/ThreatIntelDashboard';
import CveSearch from './ThreatIntel/CveSearch';
import CampaignsList from './ThreatIntel/CampaignsList';
import CampaignDetails from './ThreatIntel/CampaignDetails';
import TPRMSetting from './RiskManagement/tprmSetting';
import TPRMTools from './RiskManagement/tprmTools';
import activeVaV2 from "./BreachRisk/ActiveVaV2";
import ActiveVaIssue from './BreachRisk/ActiveVaIssue';
import ActiveVaV2Issue from './BreachRisk/ActiveVaIssue';
import VendorRiskDetails from './RiskManagement/vendorDetails';
import { dashboardAnalytics } from '../actions/auth';
import DashboardVendor from './Projects/dashboardVendor';
import RiskReview from './RiskManagement/riskReview';
import ExternalSecurityRisk from './RiskManagement/externalSecurityRisk';
import { assetsIpDelete } from '../actions/inventory';
import AssetsBasedRisk from './SecurityRisk/AssetsBasedRisk';
import SchedulingScan from './SecurityRisk/SchedulingScan';
import ScanLog from './ScanLog';
import AwsCloud from './SecurityRisk/Awscloud';
import RedTeamingIssue from './SecurityRisk/RedTeamingIssue';
import RedTeamingSimulationsNew from './SecurityRisk/RedTeamingSimulationsNew';
import RedTeamingScans from './SecurityRisk/RedTeamingScans';
import AuditLogs from './SecurityRisk/AuditLogs';
import Blacklist from './SecurityRisk/BlackList';
import VipMembers from './executiveMonitoring/VipMembers';
import Scans from './executiveMonitoring/Scans';
import Issues from './executiveMonitoring/Issues';
import Management from './Pages/Management';

const Routes = [
    {
        path: "/ui-nestable",
        name: 'Nestable',
        exact: true,
        pageTitle: "Nestable",
        component: Nestable
    },
    {
        path: "/ui-media-object",
        name: 'MediaObject',
        exact: true,
        pageTitle: "MediaObject",
        component: MediaObject
    },
    {
        path: "/ui-list-groups",
        name: 'ListGroup',
        exact: true,
        pageTitle: "ListGroup",
        component: ListGroup
    },
    {
        path: "/ui-dialogs",
        name: 'Dialogs',
        exact: true,
        pageTitle: "Dialogs",
        component: Dialogs
    },
    {
        path: "/ui-buttons",
        name: 'Buttons',
        exact: true,
        pageTitle: "Buttons",
        component: Buttons
    },
    {
        path: "/ui-colors",
        name: 'Colors',
        exact: true,
        pageTitle: "Colors",
        component: Colors
    },
    {
        path: "/table/table-normal",
        name: 'tablenormal',
        exact: true,
        pageTitle: "TableNormal",
        component: TableNormal
    },
    {
        path: "/table/table-jquery-datatable",
        name: 'tablejquerydatatable',
        exact: true,
        pageTitle: "TableJqueryDatatable",
        component: TableJqueryDatatable
    },
    {
        path: "/table/table-filter",
        name: 'tablefilter',
        exact: true,
        pageTitle: "TableFilter",
        component: TableFilter
    },
    {
        path: "/table/table-editable",
        name: 'tableeditable',
        exact: true,
        pageTitle: "TableEditable",
        component: TableEditable
    },
    {
        path: "/table/table-dragger",
        name: 'tabledragger',
        exact: true,
        pageTitle: "TableDragger",
        component: TableDragger
    },
    {
        path: "/table/table-color",
        name: 'tablecolor',
        exact: true,
        pageTitle: "TableColor",
        component: TableColor
    },
    {
        path: "/page-coming-soon",
        name: 'Page Coming Soon',
        exact: true,
        pageTitle: "Page Coming Soon",
        component: PageComingSoon
    },
    {
        path: "/widgets",
        name: 'Widgets',
        exact: true,
        pageTitle: "Widgets",
        component: Widgets
    },
    {
        path: "/page-pricing",
        name: 'Page Pricing',
        exact: true,
        pageTitle: "Page Gallery",
        component: PagePricing
    },
    {
        path: "/dashboard12",
        name: 'dashboard12',
        exact: true,
        pageTitle: "Dashboard12",
        component: Dashboard12
    },
    {
        path: "/asset",
        name: 'assetsDiscovery',
        exact: true,
        pageTitle: "Assets Discovered",
        component: AssetsDiscovery
    },
    {
        path: "/asset/vendor/:orgId",
        name: 'assetsDiscovery',
        exact: true,
        pageTitle: "Assets Discovered",
        component: AssetsDiscovery
    },
    {
        path: "/asset/:id/:ip",
        name: 'ipDetails',
        exact: true,
        pageTitle: "IP Details",
        component: HostDetails
    },
    
    {
        path: "/known-vulnerabilities",
        name: 'knownVulnerabilities',
        exact: true,
        pageTitle: "Known Vulnerabilities",
        component: KnownVulnerabilities
    },
    {
        path: "/known-vulnerabilities/vendor/:orgId",
        name: 'knownVulnerabilities',
        exact: true,
        pageTitle: "Known Vulnerabilities",
        component: KnownVulnerabilities
    },
    {
        path: "/active-va",
        name: 'infraVA',
        exact: true,
        pageTitle: "Infrastrucutre",
        component: InfrastructureVA
    },
    {
        path: "/active-va/vendor/:orgId",
        name: 'infraVA',
        exact: true,
        pageTitle: "Infrastrucutre",
        component: InfrastructureVA
    },
    {
        path: "/active-va/details/:ip/:data",
        name: 'activeVA',
        exact: true,
        pageTitle: "ActiveVA",
        component: ActiveVaDetails
    },
    {
        path: "/active-va/:finding",
        name: 'infraVA',
        exact: true,
        pageTitle: "Infrastrucutre",
        component: InfrastructureVAIP
    },
    {
        path: "/infra-va/vendor/:orgId",
        name: 'infraVA',
        exact: true,
        pageTitle: "Infrastrucutre",
        component: InfrastructureVA
    },
    {
        path: "/app-va",
        name: 'applicationVA',
        exact: true,
        pageTitle: "Application",
        component: ApplicationVA
    },
    {
        path: "/scan",
        name: 'scanPage',
        exact: true,
        pageTitle: "Scan",
        component: ScanPage
    },
    {
        path: "/ssl-certificates",
        name: 'sslCertificates',
        exact: true,
        pageTitle: "SSL Certificates",
        component: ExpiredSSLCertificates
    },
    {
        path: "/ssl-certificates/vendor/:orgId",
        name: 'sslCertificates',
        exact: true,
        pageTitle: "SSL Certificates",
        component: ExpiredSSLCertificates
    },
    {
        path: "/vulnerable-certificates",
        name: 'vulnerableCertificates',
        exact: true,
        pageTitle: "Vulnerable Certificates",
        component: ExpiredSSLCertificates
    },
    {
        path: "/vulnerable-certificates/vendor/:orgId",
        name: 'vulnerableCertificates',
        exact: true,
        pageTitle: "Vulnerable Certificates",
        component: ExpiredSSLCertificates
    },
    {
        path: "/web-technology",
        name: 'webTechnology',
        exact: true,
        pageTitle: "Web Technology",
        component: WebTechnology
    },
    {
        path: "/web-technology/vendor/:orgId",
        name: 'webTechnology',
        exact: true,
        pageTitle: "Web Technology",
        component: WebTechnology
    },
    {
        path: "/brand-mentions",
        name: 'brandMentions',
        exact: true,
        pageTitle: "Brand Mention",
        component: BrandMention
    },
    {
        path: "/seo-poisoning",
        name: 'seoPoisoning',
        exact: true,
        pageTitle: "Seo Poisoning",
        component: SeoPoisoning
    },
    {
        path: "/brand-mentions/vendor/:orgId",
        name: 'brandMentions',
        exact: true,
        pageTitle: "Brand Mention",
        component: BrandMention
    },
    {
        path: "/security-header",
        name: 'securityHeader',
        exact: true,
        pageTitle: "Security Header",
        component: SecurityHeader
    },
    {
        path: "/domains",
        name: 'domains',
        exact: true,
        pageTitle: "Domains",
        component: Domains
    },
    {
        path: "/domains/vendor/:orgId",
        name: 'domains',
        exact: true,
        pageTitle: "Domains",
        component: Domains
    },
    {
        path: "/spf-dmarc",
        name: 'spf-dmarc',
        exact: true,
        pageTitle: "SPFDmarch",
        component: SPFDMARC
    },
    {
        path: "/spf-dmarc/vendor/:orgId",
        name: 'spf-dmarc',
        exact: true,
        pageTitle: "SPFDmarch",
        component: SPFDMARC
    },
    {
        path: "/subdomains",
        name: 'subDomains',
        exact: true,
        pageTitle: "Subdomains",
        component: SubDomainDiscovery
    },
    {
        path: "/subdomains/vendor/:orgId",
        name: 'subDomains',
        exact: true,
        pageTitle: "Subdomains",
        component: SubDomainDiscovery
    },
    {
        path: "/danglingdomain",
        name: 'danglingDomain',
        exact: true,
        pageTitle: "Dangling Subdomains",
        component: DanglingSubDomains
    },
    {
        path: "/danglingdomain/vendor/:orgId",
        name: 'danglingDomain',
        exact: true,
        pageTitle: "Dangling Subdomains",
        component: DanglingSubDomains
    },
    {
        path: "/look-alike",
        name: 'lookAlikeDomains',
        exact: true,
        pageTitle: "Look-alike Domains",
        component: LookAlikeDomains
    },
    {
        path: "/look-alike/vendor/:orgId",
        name: 'lookAlikeDomains',
        exact: true,
        pageTitle: "Look-alike Domains",
        component: LookAlikeDomains
    },
    {
        path: "/social-media",
        name: 'socialMedia',
        exact: true,
        pageTitle: "Social Media Profile",
        component: SocialMediaProfile
    },
     {
        path: "/blacklist",
        name: 'blacklist',
        exact: true,
        pageTitle: "Blacklist",
        component: Blacklist
    },
      {
        path: "/blacklist/vendor/:orgId",
        name: 'blacklist',
        exact: true,
        pageTitle: "Blacklist",
        component: Blacklist
    },
    {
        path: "/social-media/vendor/:orgId",
        name: 'socialMedia',
        exact: true,
        pageTitle: "Social Media Profile",
        component: SocialMediaProfile
    },
    {
        path: "/social-media-data",
        name: 'socialMediaData',
        exact: true,
        pageTitle: "Social Media Data",
        component: SocialMediaData
    },
    {
        path: "/social-media-data/vendor/:orgId",
        name: 'socialMediaData',
        exact: true,
        pageTitle: "Social Media Data",
        component: SocialMediaData
    },
    {
        path: "/web-defacement",
        name: 'webDefacement',
        exact: true,
        pageTitle: "Web Defacement",
        component: WebDefacement
    },
    {
        path: "/web-defacement/vendor/:orgId",
        name: 'webDefacement',
        exact: true,
        pageTitle: "Web Defacement",
        component: WebDefacement
    },
    {
        path: "/mobile-apps",
        name: 'mobileApp',
        exact: true,
        pageTitle: "Mobile Applications",
        component: MobileApp
    },
    {
        path: "/mobile-apps/vendor/:orgId",
        name: 'mobileApp',
        exact: true,
        pageTitle: "Mobile Applications",
        component: MobileApp
    },
    {
        path: "/red-teaming",
        name: 'redTeaming',
        exact: true,
        pageTitle: "Red Teaming Dashboard",
        component: RedTeaming
    },
    {
        path: "/red-teaming/vendor/:orgId",
        name: 'redTeaming',
        exact: true,
        pageTitle: "Red Teaming Dashboard",
        component: RedTeaming
    },
    {
        path: "/red-teaming/simulation/:simulationId",
        name: 'simulationDetails',
        exact: true,
        pageTitle: "Simulation Details",
        component: SimulationDetails
    },
    {
        path: "/red-teaming/settings",
        name: 'redTeamingSettings',
        exact: true,
        pageTitle: "Red Teaming Settings",
        component: RedTeamingSettings
    },
    {
        path: "/red-teaming/settings/vendor/:orgId",
        name: 'redTeamingSettings',
        exact: true,
        pageTitle: "Red Teaming Settings",
        component: RedTeamingSettings
    },
    {
        path: "/red-teaming/dashboard",
        name: 'redTeamingDashboard',
        exact: true,
        pageTitle: "Red Teaming Dashboard",
        component: RedTeamingDashboard
    },
    {
        path: "/red-teaming/dashboard/vendor/:orgId",
        name: 'redTeamingDashboard',
        exact: true,
        pageTitle: "Red Teaming Dashboard",
        component: RedTeamingDashboard
    },
    {
        path: "/red-teaming/simulations/vendor/:orgId",
        name: 'redTeamingSimulations',
        exact: true,
        pageTitle: "Red Teaming Simulations",
        component: RedTeamingSimulationsNew
    },
    {
        path: "/red-teaming/assets",
        name: 'redTeamingAssets',
        exact: true,
        pageTitle: "Red Teaming Assets",
        component: RedTeamingAssets
    },
    {
        path: "/red-teaming/assets/vendor/:orgId",
        name: 'redTeamingAssets',
        exact: true,
        pageTitle: "Red Teaming Assets",
        component: RedTeamingAssets
    },
    {
        path: "/red-teaming/attack-types",
        name: 'redTeamingAttackTypes',
        exact: true,
        pageTitle: "Red Teaming Attack Types",
        component: RedTeamingAttackTypes
    },
    {
        path: "/red-teaming/attack-types/vendor/:orgId",
        name: 'redTeamingAttackTypes',
        exact: true,
        pageTitle: "Red Teaming Attack Types",
        component: RedTeamingAttackTypes
    },
    {
        path: "/red-teaming/results",
        name: 'redTeamingResults',
        exact: true,
        pageTitle: "Red Teaming Results",
        component: RedTeamingResults
    },
    {
        path: "/red-teaming/results/vendor/:orgId",
        name: 'redTeamingResults',
        exact: true,
        pageTitle: "Red Teaming Results",
        component: RedTeamingResults
    },
    {
        path: "/stolen-credentials",
        name: 'stolenCredentials',
        exact: true,
        pageTitle: "Stolen Credentials",
        component: StolenCredentials
    },
    {
        path: "/stolen-credentials/vendor/:orgId",
        name: 'stolenCredentials',
        exact: true,
        pageTitle: "Stolen Credentials",
        component: StolenCredentials
    },
    {
        path: "/telegram-monitoring",
        name: 'telegram-monitoring',
        exact: true,
        pageTitle: "Telegram Monitoring",
        component: Telegrammonitoring
    },
    {
        path: "/pending-remediation",
        name: 'pending-remediation',
        exact: true,
        pageTitle: "Pending Remediation",
        component: PendingRemdiation
    },
    {
        path: "/vip-entities",
        name: 'vip-entities',
        exact: true,
        pageTitle: "VIP Monitoring",
        component: VipEntities
    },
    {
        path: "/executive-monitoring/vip-members",
        name: 'executive-monitoring-vip-members',
        exact: true,
        pageTitle: "VIP Members",
        component: VipMembers
    },
    {
        path: "/executive-monitoring/scans",
        name: 'executive-monitoring-scans',
        exact: true,
        pageTitle: "Executive Monitoring Scans",
        component: Scans
    },
    {
        path: "/executive-monitoring/issues",
        name: 'executive-monitoring-issues',
        exact: true,
        pageTitle: "Scan Issues & Results",
        component: Issues
    },
    {
        path: "/vip-entities/:id",
        name: 'vip-entities',
        exact: true,
        pageTitle: "VIP Monitoring",
        component: VipEntities
    },
    {
        path: "/telegram-monitoring/vendor/:orgId",
        name: 'telegram-monitoring',
        exact: true,
        pageTitle: "Telegram Monitoring",
        component: Telegrammonitoring
    },
    {
        path: "/cve",
        name: 'CVE Information',
        exact: true,
        pageTitle: "CVE Information",
        component: CVEinformation
    },
    {
        path: "/cve/vendor/:orgId",
        name: 'CVE Information',
        exact: true,
        pageTitle: "CVE Information",
        component: CVEinformation
    },
    {
        path: "/product-vendor/:data",
        name: 'CVE Information',
        pageTitle: "CVE Information",
        component: CVEinformation
    },
    {
        path: "/cve/:cveId",
        name: 'CVE Information',
        exact: true,
        pageTitle: "CVE Information Edit",
        component: CVEinformationEdit
    },
    {
        path: "/vendor-product/vendor/:orgId",
        name: 'Vendor & Product',
        exact: true,
        pageTitle: "Vendor & Product",
        component: vendorProduct
    },
    {
        path: "/vendor-product",
        name: 'Vendor & Product',
        exact: true,
        pageTitle: "Vendor & Product",
        component: vendorProduct
    },
    {
        path: "/highRiskVulnerability",
        name: 'High & Risk',
        exact: true,
        pageTitle: "High & Risk",
        component: HighRisk
    },
    {
        path: "/postman-monitoring",
        name: 'postman-monitoring',
        exact: true,
        pageTitle: "PostMan Monitoring",
        component:PostmanMonitoring
    },
    {
        path: "/postman-monitoring/vendor/:orgId",
        name: 'postman-monitoring',
        exact: true,
        pageTitle: "PostMan Monitoring",
        component:PostmanMonitoring
    },
    {
        path: "/postman-monitoring/:routeId",
        name: 'postman-monitoring-detail',
        exact: true,
        pageTitle: "PostMan Monitoring",
        component:PostManMonitoringDetail
    },
    {
        path: "/pii",
        name: 'PII',
        exact: true,
        pageTitle: "PII",
        component: PII
    },
    {
        path: "/pii/vendor/:orgId",
        name: 'PII',
        exact: true,
        pageTitle: "PII",
        component: PII
    },
    {
        path: "/phishing",
        name: 'phishingPage',
        exact: true,
        pageTitle: "Phishing Page",
        component: PhishingPage
    },
    {
        path: "/phishing/vendor/:orgId",
        name: 'phishingPage',
        exact: true,
        pageTitle: "Phishing Page",
        component: PhishingPage
    },
    {
        path: "/pastebin-search",
        name: 'pastebinSearch',
        exact: true,
        pageTitle: "Pastebin Search",
        component: PasteBin
    },
    {
        path: "/pastebin-search/vendor/:orgId",
        name: 'pastebinSearch',
        exact: true,
        pageTitle: "Pastebin Search",
        component: PasteBin
    },
    {
        path: "/dark-web",
        name: 'darkweb',
        exact: true,
        pageTitle: "Dark Web",
        component: DarkWeb
    },
    {
        path: "/dark-web/vendor/:orgId",
        name: 'darkweb',
        exact: true,
        pageTitle: "Dark Web",
        component: DarkWeb
    },
    {
        path: "/malware-credentials",
        name: 'malwareCredentials',
        exact: true,
        pageTitle: "Malware Credentials",
        component: MalwareCredentials
    },
    {
        path: "/malware-credentials/vendor/:orgId",
        name: 'malwareCredentials',
        exact: true,
        pageTitle: "Malware Credentials",
        component: MalwareCredentials
    },
    {
        path: "/leaked-sessions",
        name: 'leakedSessions',
        exact: true,
        pageTitle: "Leaked Sessions",
        component: LeakedSessions
    },
    {
        path: "/leaked-sessions/vendor/:orgId",
        name: 'leakedSessions',
        exact: true,
        pageTitle: "Leaked Sessions",
        component: LeakedSessions
    },
    
    {
        path: "/source-code",
        name: 'sourceCode',
        exact: true,
        pageTitle: "Source Code Leakage",
        component: SourceCodeLeakage
    },
    {
        path: "/source-code/vendor/:orgId",
        name: 'sourceCode',
        exact: true,
        pageTitle: "Source Code Leakage",
        component: SourceCodeLeakage
    },
    {
        path: "/ip-blacklist",
        name: 'ipBlacklist',
        exact: true,
        pageTitle: "IP Blacklist",
        component: IPBlacklist
    },
    {
        path: "/ip-blacklist/vendor/:orgId",
        name: 'ipBlacklist',
        exact: true,
        pageTitle: "IP Blacklist",
        component: IPBlacklist
    },
    {
        path: "/feed-information/:orgId",
        name: 'feedInformation',
        exact: true,
        pageTitle: "Feed Information",
        component: FeedInformation
    },
    {
        path: "/show-details/:id",
        name: 'show',
        exact: true,
        pageTitle: "Show Details",
        component: ShowInformation
    },
    {
        path: "/cloud-bucket/vendor/:orgId",
        name: 'cloudBucket',
        exact: true,
        pageTitle: "Cloud Buckets",
        component: CloudBuckets
    },
    {
        path: "/cloud-bucket",
        name: 'cloudBucket',
        exact: true,
        pageTitle: "Cloud Buckets",
        component: CloudBuckets
    },
    {
        path: "/cloud-account",
        name: 'cloudAccount',
        exact: true,
        pageTitle: "Cloud Security",
        component: CloudAccounts
    },
    {
        path: "/account-details/:accountId",
        name: 'accountDetails',
        exact: true,
        pageTitle: "Account Details",
        component: CloudAccountDetails
    },
    {
        path: "/scan-results/:scanId",
        name: 'scanResults',
        exact: true,
        pageTitle: "Scan Results",
        component: ScanResults
    },
    {
        path: "/integrations",
        name: 'integrations',
        exact: true,
        pageTitle: "Integrations",
        component: Integrations
    },
    {
        path: "/alert-integrations",
        name: 'alert-integrations',
        exact: true,
        pageTitle: "Alert Integrations",
        component: AlertIntegration
    },
    {
        path: "/integrations/vendor/:orgId",
        name: 'integrations',
        exact: true,
        pageTitle: "Integrations",
        component: Integrations
    },
    {
        path: "/summary",
        name: 'summary',
        exact: true,
        pageTitle: "Summary",
        component: Summary
    },
    {
        path: "/asm-details",
        name: 'asm',
        exact: true,
        pageTitle: "ASMDashboard",
        component: ASMDashboard
    },
    {
        path: "/asm-details/vendor/:orgId",
        name: 'asm',
        exact: true,
        pageTitle: "ASMDashboard",
        component: ASMDashboard
    },
    {
        path: "/data-details",
        name: 'dataDetails',
        exact: true,
        pageTitle: "DataDashboard",
        component: DataDashboard
    },
    {
        path: "/data-details/vendor/:orgId",
        name: 'dataDetails',
        exact: true,
        pageTitle: "DataDashboard",
        component: DataDashboard
    },
    {
        path: "/brand-details",
        name: 'brandDetails',
        exact: true,
        pageTitle: "BrandDashboard",
        component: BrandDashboard
    },
    {
        path: "/brand-details/vendor/:orgId",
        name: 'brandDetails',
        exact: true,
        pageTitle: "BrandDashboard",
        component: BrandDashboard
    },
    {
        path: "/new-summary",
        name: 'newSummary',
        exact: true,
        pageTitle: "New Summary",
        component: NewSummary
    },
    {
        path: "/vendorDetails/:orgId",
        name: 'summary',
        exact: true,
        pageTitle: "Summary",
        component: Summary
    },
    {
        path: "/vendor-summary",
        name: 'vendorSummary',
        exact: true,
        pageTitle: "VendorSummary",
        component: VendorSummary
    },
    {
        path: "/vendor-summary/vendor/:orgId",
        name: 'vendorSummary',
        exact: true,
        pageTitle: "VendorSummary",
        component: VendorSummary
    },
    {
        path: "/breach-summary",
        name: 'breachSummary',
        exact: true,
        pageTitle: "Breach Summary",
        component: BreachSummary
    },
    {
        path: "/breach-summary/vendor/:orgId",
        name: 'breachSummary',
        exact: true,
        pageTitle: "Breach Summary",
        component: BreachSummary
    },
    
    

    {
        path: "/task-board",
        name: 'Taskboard',
        exact: true,
        pageTitle: "Taskboard",
        component: Taskboard
    },
    {
        path: "/notifications",
        name: 'Notifications',
        exact: true,
        pageTitle: "Notifications",
        component: Notifications
    },
    {
        path: "/tabs",
        name: 'Tabs',
        exact: true,
        pageTitle: "Tabs",
        component: Tabs
    },
    {
        path: "/progressbars",
        name: 'ProgressBars',
        exact: true,
        pageTitle: "ProgressBars",
        component: ProgressBars
    },
    {
        path: "/modals",
        name: 'Modals',
        exact: true,
        pageTitle: "Modals",
        component: Modals
    },
    {
        path: "/ui-range-sliders",
        name: 'RangeSliders',
        exact: true,
        pageTitle: "RangeSliders",
        component: RangeSliders
    },
    {
        path: "/page-gallery",
        name: 'Page Gallery',
        exact: true,
        pageTitle: "Page Gallery",
        component: PageGallery
    },
    {
        path: "/page-search-results",
        name: 'Page Search Results',
        exact: true,
        pageTitle: "Page Search Results",
        component: PageSearchResult
    },
    {
        path: "/page-timeline",
        name: 'Page Timeline',
        exact: true,
        pageTitle: "Page Timeline",
        component: PageTimeline
    },
    {
        path: "/page-invoices",
        name: 'Page Invoice',
        exact: true,
        pageTitle: "Page Invoice",
        component: PageInvoice
    },
    {
        path: "/page-invoices-details",
        name: 'Page Invoice Details',
        exact: true,
        pageTitle: "Page Invoice Details",
        component: PageInvoiceDetails
    },
    {
        path: "/page-testimonials",
        name: 'Page Testimonials',
        exact: true,
        pageTitle: "Page Testimonials",
        component: PageTestimonials
    },
    {
        path: "/page-user-list",
        name: 'Page User List',
        exact: true,
        pageTitle: "Page User List",
        component: pageUserList
    },
    {
        path: "/profile",
        name: 'Page Profile',
        exact: true,
        pageTitle: "Page Profile",
        component: pageProfile
    },
    {
        path: "/profile/vendor/:orgId",
        name: 'Page Profile',
        exact: true,
        pageTitle: "Page Profile",
        component: pageProfile
    },
    {
        path: "/company-profile",
        name: 'Company Profile',
        exact: true,
        pageTitle: "Company Profile",
        component: CompanyProfile
    },
    {
        path: "/settings",
        name: 'Settings',
        exact: true,
        pageTitle: "Settings",
        component: Settings
    },
    {
        path: "/configuration",
        name: 'Configuration',
        exact: true,
        pageTitle: "Configuration",
        component: Configuration
    },
    {
        path: "/subscription",
        name: 'Subscriptions',
        exact: true,
        pageTitle: "Subscriptions",
        component: Subscription
    },
    {
        path: "/page-blank",
        name: 'Page Blank',
        exact: true,
        pageTitle: "Page Blank",
        component: pageBlank
    },
    {
        path: "/page-blog-post",
        name: 'Page Blog post',
        exact: true,
        pageTitle: "Page Blog Post",
        component: PageBlogPost
    },
    {
        path: "/page-blog",
        name: 'Page Blog',
        exact: true,
        pageTitle: "Page Blog",
        component: PageBlog
    },
    {
        path: "/clients",
        name: 'Clients',
        exact: true,
        pageTitle: "Clients",
        component: Clients
    },
    {
        path: "/clients/vendor/:orgId",
        name: 'Clients',
        exact: true,
        pageTitle: "Clients",
        component: Clients
    },
    {
        path: "/trial-request",
        name: 'TrialRequest',
        exact: true,
        pageTitle: "TrialRequest",
        component: TrialRequest
    },
    {
        path: "/takedown-request",
        name: 'TakeDownRequest',
        exact: true,
        pageTitle: "TakeDownRequest",
        component: TakeDownRequest
    },
    {
        path: "/trial-request/vendor/:orgId",
        name: 'TrialRequest',
        exact: true,
        pageTitle: "TrialRequest",
        component: TrialRequest
    },
    {
        path: "/vendor",
        name: 'Vendors',
        exact: true,
        pageTitle: "Vendors",
        component: Vendors
    },
    {
        path: '/forest-view',
        name: 'ForestView',
        exact: true,
        pageTitle: "Forest View",
        component: ForestView
    },
    {
        path: '/forest-view/:orgId',
        name: 'ForestView',
        exact: true,
        pageTitle: "Forest View",
        component: ForestView
    },
    {
        path: '/forest-rating',
        name: 'ForestRatingList',
        exact: true,
        pageTitle: "Forest Rating List",
        component: ForestRatingPage
    },
    {
        path: "/vendor/:orgId",
        name: 'Vendors',
        exact: true,
        pageTitle: "Vendors",
        component: Vendors
    },
    
    {
        path: "/cve-monitoring/:orgId",
        name: 'cve-monitoring',
        exact: true,
        pageTitle: "Cve Monitoring",
        component: cveMonitoring
    },
    {
        path: "/cve-monitoring",
        name: 'cve-monitoring',
        exact: true,
        pageTitle: "Cve Monitoring",
        component: cveMonitoring
    },
    {
        path: "/app-todo",
        name: 'TodoList',
        exact: true,
        pageTitle: "TodoList",
        component: TodoList
    },
    {
        path: "/page-news",
        name: 'Page News',
        exact: true,
        pageTitle: "Page News",
        component: PageNews
    },
    {
        path: "/page-social",
        name: 'Page Social',
        exact: true,
        pageTitle: "Page Social",
        component: PageSocial
    },
    {
        path: "/app-jVector-map",
        name: 'JVector',
        exact: true,
        pageTitle: "JVector",
        component: jVector
    },
    {
        path: "/chart/chart-apex",
        name: 'ApexChart',
        exact: true,
        pageTitle: "ApexChart",
        component: ApexChart
    },
    {
        path: "/app-calendar",
        name: 'Calendar',
        exact: true,
        pageTitle: "Calendar",
        component: Calendar
    },
    {
        path: "/ui-typography",
        name: 'Typography',
        exact: true,
        pageTitle: "Typography",
        component: Typography
    },
    {
        path: "/ui-bootstrap",
        name: 'Bootstrap',
        exact: true,
        pageTitle: "Bootstrap",
        component: Bootstrap
    },
    {
        path: "/ui-icons-themify",
        name: 'Themify',
        exact: true,
        pageTitle: "Themify",
        component: Themify
    },
    {
        path: "/ui-icons-line",
        name: 'simpleLine',
        exact: true,
        pageTitle: "SimpleLine",
        component: SimpleLine
    },
    {
        path: "/ui-icons",
        name: 'icons',
        exact: true,
        pageTitle: "Icons",
        component: Icons
    },
    {
        path: "/app-ticket-details",
        name: 'ticketDetails',
        exact: true,
        pageTitle: "TicketDetails",
        component: TicketDetails
    },
    {
        path: "/app-ticket",
        name: 'ticketList',
        exact: true,
        pageTitle: "TicketList",
        component: TicketList
    },
    {
        path: "/app-project-list",
        name: 'projectList',
        exact: true,
        pageTitle: "ProjectList",
        component: ProjectList
    },
    {
        path: "/invite-user",
        name: 'inviteUser',
        exact: true,
        pageTitle: "Invite User",
        component: InviteUser
    },
    {
        path: "/tprm/assessment-campaign",
        name: 'riskManagementDashboard',
        exact: true,
        pageTitle: "Risk Management Dashboard",
        component: RiskManagement
    },
    {
        path: "/create-questionnaire",
        name: 'CreateQuestionnaire',
        exact: true,
        pageTitle: "Create Template",
        component: CreateTemplate
    },
    {
        path: "/edit-questionnaire/:_id",
        name: 'EditQuestionnaire',
        exact: true,
        pageTitle: "Edit Questionnaire ",
        component: CreateTemplate
    },
    {
        path: "/questionnaire/send-questionnaires/:templateId",
        name: 'sendquestionnaires',
        exact: true,
        pageTitle: "Send-Questionnaires",
        component: SendQuestionnaires
    },
    {
        path: "/tprm/questionnaires",
        name: 'questionnaires',
        exact: true,
        pageTitle: "Questionnaires",
        component: Questionnaires
    },
    {
        path: "/tprm/risk-register",
        name: 'Risk Register',
        exact: true,
        pageTitle: "Risk Register",
        component: RiskRegister
    },
    {
        path: "/risk-register-vendor",
        name: 'Vendor Risk Register',
        exact: true,
        pageTitle: "Vendor Risk Register",
        component: VendorRiskRegister
    },
    {
        path: "/tprm/external-security-risks",
        name: 'External Security Risks',
        exact: true,
        pageTitle: "External Security Risks",
        component: ExternalSecurityRisk
    },
    {
        path: "/risk-management-dashboard-vendor",
        name: "Vendor Risk Management Dashboard",
        exact: true,
        pageTitle: "Vendor Risk Management Dashboard",
        component: VendorQuestionnaireDashboard
    },
    {
        path: "/tprm/settings",
        name: "Settings",
        exact: true,
        pageTitle: "Settings",
        component: TPRMSetting
    },
    {
        path: "/tprm/tools",
        name: "Tools",
        exact: true,
        pageTitle: "Tools",
        component: TPRMTools,
    },
    {
        path: "/questionnaire-details/:_id",
        name: "Show Details Vendor Questionnaires",
        exact: true,
        pageTitle: "Show Details Vendor Questionnaires",
        component: ShowDetailsVendorQuestionnaires
    },
    {
        path: "/questionnaire-details/:_id/:chatId",
        name: "Show Details Vendor Questionnaires",
        exact: true,
        pageTitle: "Show Details Vendor Questionnaires",
        component: ShowDetailsVendorQuestionnaires
    },
    {
        path: "/tprm/review-response/:_id",
        name: "Review Response",
        exact: true,
        pageTitle: "Review Response",
        component: ReviewResponse
    },
    {
        path: "/tprm/review-risk/:_id",
        name: 'Risk Review',
        exact: true,
        pageTitle: "Risk Review",
        component: RiskReview
    },
    {
        path: "/review-response/:_id/:chatId",
        name: "Review Response",
        exact: true,
        pageTitle: "Review Response",
        component: ReviewResponse
    },
    {
        path: "/tprm/risk-register-details/:_id/:_categoryId/:_questionId/:assigneeOrganisationId",
        name: "Risk Register Details",
        exact: true,
        pageTitle: "Risk Register Details",
        component: RiskRegisterChat
    },
    {
        path: "/risk-register-vendor-details/:_id/:_categoryId/:_questionId",
        name: "Risk Register Details",
        exact: true,
        pageTitle: "Risk Register Details",
        component: RiskRegisterVendorChat
    },
    {
        path: "/tprm/vendor/user/:id",
        name: 'inviteUser',
        exact: true,
        pageTitle: "Invite User",
        component: InviteUser
    },
    {
        path: "/tprm/vendor",
        name: 'Vendor Risk',
        exact: true,
        pageTitle: "Vendor Risk",
        component: VendorRisk
    },
    {
        path: "/cloud-integration",
        name: 'Cloud Integration',
        exact: true,
        pageTitle: "Cloud Integration",
        component: AwsCloud
    },
    {
        path: "/forest-view/companies",
        name: 'Forest View Company List',
        exact: true,
        pageTitle: "Forest View Company List",
        component: VendorRisk
    },
    {
        path: "/tprm/trust-panel",
        name: 'Trust Panel',
        exact: true,
        pageTitle: "Trust Panel",
        component: TrustPanel
    },
    {
        path: "/trust-panel/vendor/:subOrgId",
        name: 'Trust Panel',
        exact: true,
        pageTitle: "Trust Panel",
        component: TrustPanel
    },
    {
        path: "/application-security",
        name: 'Application Security',
        exact: true,
        pageTitle: "Application Security",
        component: ApplicationSecurity
    },
    {
        path: "/invite-user/vendor/:orgId",
        name: 'inviteUser',
        exact: true,
        pageTitle: "Invite User",
        component: InviteUser
    },
    {
        path: "/user/:id",
        name: 'inviteUser',
        exact: true,
        pageTitle: "Invite User",
        component: InviteUser
    },
    {
        path: "/app-chat",
        name: 'chat',
        exact: true,
        pageTitle: "Chat",
        component: Chat
    },
    {
        path: "/app-inbox/:alertId/details",
        name: 'details',
        exact: true,
        pageTitle: "Details",
        component: Details
    },
    {
        path: "/app-compose",
        name: 'compose',
        exact: true,
        pageTitle: "Compose",
        component: Compose
    },
    {
        path: "/app-inbox",
        name: 'inbox',
        exact: true,
        pageTitle: "Inbox",
        component: Inbox
    },
    {
        path: "/app-contact2",
        name: 'gridView',
        exact: true,
        pageTitle: "Grid View",
        component: GridView
    },
    {
        path: "/app-contact",
        name: 'listView',
        exact: true,
        pageTitle: "List View",
        component: ListView
    },
    {
        path: "/form/form-wizard",
        name: 'formwizard',
        exact: true,
        pageTitle: "FormWizard",
        component: FormWizard
    },
    {
        path: "/form/form-validation",
        name: 'formvalidation',
        exact: true,
        pageTitle: "FormValidation",
        component: FormValidation
    },
    {
        path: "/form/form-summernote",
        name: 'formsummernote',
        exact: true,
        pageTitle: "FormSummernote",
        component: FormSummernote
    },
    {
        path: "/form/form-editors",
        name: 'formseditors',
        exact: true,
        pageTitle: "FormsEditors",
        component: FormsEditors
    },
    {
        path: "/form/form-dragdropupload",
        name: 'formdragdropupload',
        exact: true,
        pageTitle: "FormDragdropupload",
        component: FormDragdropupload
    },
    {
        path: "/form/form-cropping",
        name: 'formscropping',
        exact: true,
        pageTitle: "FormsCropping",
        component: FormCropping
    },
    {
        path: "/form/form-basic",
        name: 'formbasic',
        exact: true,
        pageTitle: "FormBasic",
        component: FormBasic
    },
    {
        path: "/form/form-advanced",
        name: 'formadvanced',
        exact: true,
        pageTitle: "FormAdvanced",
        component: FormAdvanced
    },
    // {
    //     path: "/dashboard11",
    //     name: 'dashboard11',
    //     exact: true,
    //     pageTitle: "Dashboard11",
    //     component: Dashboard11
    // },
    // {
    //     path: "/dashboard10",
    //     name: 'dashboard10',
    //     exact: true,
    //     pageTitle: "Dashboard10",
    //     component: Dashboard10
    // },
    // {
    //     path: "/dashboard9",
    //     name: 'dashboard9',
    //     exact: true,
    //     pageTitle: "Dashboard9",
    //     component: Dashboard9
    // },
    // {
    //     path: "/dashboard8",
    //     name: 'dashboard8',
    //     exact: true,
    //     pageTitle: "Dashboard8",
    //     component: Dashboard8
    // },
    // {
    //     path: "/dashboard7",
    //     name: 'dashboard7',
    //     exact: true,
    //     pageTitle: "Dashboard7",
    //     component: Dashboard7
    // },
    // {
    //     path: "/dashboard6",
    //     name: 'dashboard6',
    //     exact: true,
    //     pageTitle: "Dashboard6",
    //     component: Dashboard6
    // },
    // {
    //     path: "/dashboard5",
    //     name: 'dashboard5',
    //     exact: true,
    //     pageTitle: "Dashboard5",
    //     component: Dashboard5
    // },
    // {
    //     path: "/dashboard4",
    //     name: 'dashboard4',
    //     exact: true,
    //     pageTitle: "Dashboard4",
    //     component: Dashboard4
    // },
    // {
    //     path: "/dashboard3",
    //     name: 'dashboard3',
    //     exact: true,
    //     pageTitle: "Dashboard3",
    //     component: Dashboard3
    // },
    // {
    //     path: "/dashboard2",
    //     name: 'dashboard2',
    //     exact: true,
    //     pageTitle: "Dashboard2",
    //     component: Dashboard2
    // },
    {
        path: "/",
        name: 'dashboard',
        exact: true,
        pageTitle: "Dashboard",
        component: Summary
    },
    {
        path: "/dashboard/vendor/:orgid",
        name: 'dashboard',
        exact: true,
        pageTitle: "Dashboard",
        component: Summary
    },
    {
        path: "/vendor/:orgid",
        name: 'dashboard',
        exact: true,
        pageTitle: "Dashboard",
        component: Summary
    },
    {
        path: "/technology",
        name: 'technology',
        exact: true,
        pageTitle: "Technology",
        component: Technology
    },
    {
        path: "/technology/vendor/:orgid",
        name: 'technology',
        exact: true,
        pageTitle: "Technology",
        component: Technology
    },
    {
        path: "/login",
        name: 'login',
        exact: true,
        pageTitle: "Tables",
        component: Login
    },
    {
        path: "/signup",
        name: 'signup',
        exact: true,
        pageTitle: "Tables",
        component: Signup
    },
    {
        path: "/forgotpassword",
        name: 'forgotpassword',
        exact: true,
        pageTitle: "Tables",
        component: ForgotPassword
    },
    {
        path: "/maintenance",
        name: 'maintenance',
        exact: true,
        pageTitle: "Maintenance",
        component: Maintenance
    },
    {
        path: "/notfound",
        name: 'notfound',
        exact: true,
        pageTitle: "Tables",
        component: NotFound
    },
    {
        path: "/threat-intel/dashboard",
        name: 'threatIntelDashboard',
        exact: true,
        pageTitle: "Threat Intelligence Dashboard",
        component: ThreatIntelDashboard
    },
    {
        path: "/threat-intel/search",
        name: 'threatIntelSearch',
        exact: true,
        pageTitle: "Threat Intelligence Search",
        component: ThreatIntelSearch
    },
    {
        path: "/threat-intel/ransomware",
        name: 'ransomwareTracker',
        exact: true,
        pageTitle: "Ransomware Tracker",
        component: RansomwareTracker
    },
    {
        path: "/threat-intel/hacktivism",
        name: 'hacktivismTracker',
        exact: true,
        pageTitle: "Hacktivism Tracker",
        component: HacktivismTracker
    },
    {
        path: "/threat-intel/cve-search",
        name: 'cveSearch',
        exact: true,
        pageTitle: "CVE Search",
        component: CveSearch
    },
    {
        path: "/threat-intel/threat-actors",
        name: 'threatActors',
        exact: true,
        pageTitle: "Threat Actors",
        component: ThreatActorList
    },
    {
        path: "/threat-intel/threat-actors/:id",
        name: 'threatActorDetails',
        exact: true,
        pageTitle: "Threat Actor Details",
        component: ThreatActorDetails
    },
    {
        path: "/threat-intel/campaigns",
        name: 'campaigns',
        exact: true,
        pageTitle: "Campaigns",
        component: CampaignsList
    },
    {
        path: "/threat-intel/campaigns/:id",
        name: 'campaignDetails',
        exact: true,
        pageTitle: "Campaign Details",
        component: CampaignDetails
    },
    {
        path: "/threat-intel/feeds",
        name: 'threatIntelFeeds',
        exact: true,
        pageTitle: "News Feeds",
        component: ThreatIntelFeeds
    },
    {
        path: "/threat-intel/intel-feed",
        name: 'threatIntelFeed',
        exact: true,
        pageTitle: "Threat Intel Feed",
        component: ThreatIntelFeed
    },
    {
        path: "/custom-report/:id",
        name: 'customReport',
        exact: true,
        pageTitle: "Custom Report",
        component: CustomReport
    },
    {

        path: "/consolidated-assets",
        name: 'consolidatedAssets',
        exact: true,
        pageTitle: "Consolidated Assets",
        component: ConsolidatedAssets
    },
    {
        path: "/consolidated-risks",
        name: 'consolidatedRisks',
        exact: true,
        pageTitle: "Consolidated Risks",
        component: ConsolidatedRisks
    },
    {
        path: "/consolidated-assets/vendor/:orgId",
        name: 'consolidatedAssets',
        exact: true,
        pageTitle: "Consolidated Assets",
        component: ConsolidatedAssets
    },
    {
        path: "/consolidated-assets/:ip",
        name: 'AssetsBasedRisk',
        exact: true,
        pageTitle: "Assets Based Risk",
        component: AssetsBasedRisk
    },
    {
        path: "/active-scan/schedule",
        name: 'schedulingScan',
        exact: true,
        pageTitle: "Scheduling Scan",
        component: SchedulingScan
    },
    {
        path: "/active-vaV2",
        name: 'active-vaV2',
        exact: true,
        pageTitle: "Active-va V2",
        component: activeVaV2
    },
    {
        path: "/active-vaV2/vendor/:orgId",
        name: 'active-vaV2',
        exact: true,
        pageTitle: "Active-va V2",
        component: activeVaV2
    },
    {
        path: "/active-scan/issue",
        name: 'active-vaV2',
        exact: true,
        pageTitle: "Active-Va",
        component: ActiveVaV2Issue
    },
    {
        path: "/tprm/vendor/:id",
        name: 'Vendor Risk Details',
        exact: true,
        pageTitle: "Vendor Risk Details",
        component: VendorRiskDetails
    },
    {
        path: "/tprm/dashboard",
        name: 'Dashboard Vendor',
        exact: true,
        pageTitle: "Dashboard Vendor",
        component: DashboardVendor
    },
    {
        path: "/scan-logs",
        name: 'scanLogs',
        exact: true,
        pageTitle: "Scan Logs",
        component: ScanLog
    },
    {
        path: "/red-teaming/issues",
        name: 'redTeamingIssues',
        exact: true,
        pageTitle: "Red Teaming Issues",
        component: RedTeamingIssue
    },
    {
        path: "/red-teaming/issues/vendor/:orgId",
        name: 'redTeamingIssues',
        exact: true,
        pageTitle: "Red Teaming Issues",
        component: RedTeamingIssue
    },
    {
        path: "/red-teaming/simulations",
        name: 'redTeamingSimulations',
        exact: true,
        pageTitle: "Red Teaming Simulations",
        component: RedTeamingSimulationsNew
    },
    {
        path: "/red-teaming/scans",
        name: 'redTeamingScans',
        exact: true,
        pageTitle: "Red Teaming Scans",
        component: RedTeamingScans
    },
    {
        path: "/red-teaming/scans/vendor/:orgId",
        name: 'redTeamingScans',
        exact: true,
        pageTitle: "Red Teaming Scans",
        component: RedTeamingScans
    },
    {
        path: "/audit-logs",
        name: "auditLogs",
        exact: true,
        pageTitle: "Audit Logs",
        component: AuditLogs
    },
    {
        path: "/audit-logs/vendor/:orgId",
        name: "auditLogs",
        exact: true,
        pageTitle: "Audit Logs",
        component: AuditLogs
    },
    {
        path: "/manage",
        name: "Manage",
        exact: true,
        pageTitle: "Manage",
        component: Management
    },
    {
        path: "/management/vendor/:orgId",
        name: "management",
        exact: true,
        pageTitle: "Domain Management",
        component: Management
    }

];

export default Routes;